import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './andersoncruz_personal_acompanhamentopresencial.module.scss';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const WHATSAPP_NUMBER = '5517981132120';

const wa = (text: string) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

const MSG_AULA_AVULSA =
    'Olá, Anderson! Vi a página de acompanhamento presencial e quero saber sobre aula avulsa / hora-aula (R$ 45,00). Podemos conversar?';

const MSG_IND_5 =
    'Olá, Anderson! Tenho interesse no plano mensal individual presencial, 5x na semana (R$ 800,00, R$ 40,00/h aula). Podemos alinhar agenda?';
const MSG_IND_4 =
    'Olá, Anderson! Tenho interesse no plano mensal individual presencial, 4x na semana (R$ 640,00, R$ 40,00/h aula). Podemos alinhar agenda?';
const MSG_IND_3 =
    'Olá, Anderson! Tenho interesse no plano mensal individual presencial, 3x na semana (R$ 540,00, R$ 45,00/h aula). Podemos alinhar agenda?';
const MSG_IND_2 =
    'Olá, Anderson! Tenho interesse no plano mensal individual presencial, 2x na semana (R$ 360,00, R$ 45,00/h aula). Podemos alinhar agenda?';

const MSG_DUP_5 =
    'Olá, Anderson! Quero o plano mensal dupla/casal presencial, 5x na semana (R$ 1.200,00, R$ 30,00/h aula por pessoa). Podemos conversar?';
const MSG_DUP_4 =
    'Olá, Anderson! Quero o plano mensal dupla/casal presencial, 4x na semana (R$ 1.120,00, R$ 35,00/h aula por pessoa). Podemos conversar?';
const MSG_DUP_3 =
    'Olá, Anderson! Quero o plano mensal dupla/casal presencial, 3x na semana (R$ 900,00, R$ 37,50/h aula por pessoa). Podemos conversar?';
const MSG_DUP_2 =
    'Olá, Anderson! Quero o plano mensal dupla/casal presencial, 2x na semana (R$ 600,00, R$ 37,50/h aula por pessoa). Podemos conversar?';

const MSG_GERAL =
    'Olá, Anderson! Li sobre o acompanhamento presencial e quero sua orientação para escolher o melhor plano (individual ou dupla). Podemos conversar?';

const Andersoncruz_personal_acompanhamentopresencial: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.andersoncruz_personal_acompanhamentopresencial}>
            <div className={styles.page}>
                <header className={styles.header}>
                    <Link
                        to="/andersoncruz_personal"
                        state={{ skipLoader: true }}
                        className={styles.backButton}
                        aria-label="Voltar ao cartão digital"
                    >
                        <FaArrowLeft />
                    </Link>
                    <div className={styles.headerText}>
                        <p className={styles.eyebrow}>Anderson Cruz</p>
                        <h1 className={styles.title}>Acompanhamento Presencial</h1>
                    </div>
                </header>

                <p className={styles.intro}>
                    Treino 100% individualizado, com o personal ao seu lado em cada série, com estratégia, segurança e
                    evolução medida no detalhe.
                </p>

                <div className={styles.contentFlow}>
                    <section className={styles.section} aria-labelledby="pres-sobre-heading">
                        <h2 id="pres-sobre-heading" className={styles.sectionTitle}>
                            Como funciona o presencial
                        </h2>
                        <p className={styles.prose}>
                            O acompanhamento presencial com Personal Trainer é totalmente individualizado, de acordo com
                            seus objetivos, necessidades e limitações. Cada treino é planejado de forma estratégica
                            para evolução com segurança, qualidade e constância.
                        </p>
                        <p className={styles.prose}>
                            O foco não é apenas “passar exercícios”: é acompanhar de perto execução, intensidade e
                            progressão. Os treinos podem incluir:
                        </p>
                        <ul className={styles.bulletList}>
                            <li>
                                Treinamento de força para hipertrofia, emagrecimento, condicionamento ou performance;
                            </li>
                            <li>
                                Mobilidade e alongamento quando houver limitações articulares, dificuldade de movimento
                                ou necessidade de melhora postural;
                            </li>
                            <li>
                                Técnicas de execução, correções em tempo real e ajustes para maior eficiência e menor
                                risco de lesões;
                            </li>
                            <li>
                                Periodização organizada, com volume, intensidade e progressão alinhados à sua evolução.
                            </li>
                        </ul>
                    </section>

                    <section className={styles.section} aria-labelledby="avaliacao-heading">
                        <h2 id="avaliacao-heading" className={styles.sectionTitle}>
                            Avaliação e acompanhamento da evolução
                        </h2>
                        <p className={styles.prose}>
                            Antes do início, realizamos avaliação física e postural completa: postura, assimetrias,
                            pontos fracos, mobilidade, dificuldades de movimento e condicionamento atual.
                        </p>
                        <p className={styles.prose}>
                            Ao longo do processo, acompanhamos a evolução com medidas corporais e fotos comparativas, para
                            você enxergar com clareza os resultados da jornada.
                        </p>
                    </section>

                    <div className={styles.highlightBox}>
                        <h2 className={styles.highlightTitle}>Objetivo do acompanhamento presencial</h2>
                        <p className={styles.prose}>
                            Oferecer um treino seguro, eficiente e totalmente personalizado, para que você evolua da
                            melhor forma possível dentro da sua realidade e do seu objetivo.
                        </p>
                    </div>

                    <section className={styles.pricingSection} aria-labelledby="hora-aula-heading">
                        <h2 id="hora-aula-heading" className={styles.pricingTitle}>
                            Aula avulsa
                        </h2>
                        <div className={styles.planCard}>
                            <p className={styles.planName}>Valor hora/aula</p>
                            <p className={styles.planPeriod}>R$ 45,00</p>
                            <p className={styles.planPrice}>
                                Ideal para experimentar o método, retomar após uma pausa ou alinhar execução com
                                orientação profissional pontual.
                            </p>
                            <a
                                href={wa(MSG_AULA_AVULSA)}
                                className={styles.planWhatsapp}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <WhatsappIcon height="18" color="#ffffff" />
                                <span>Quero hora/aula avulsa</span>
                            </a>
                        </div>
                    </section>

                    <section className={styles.section} aria-labelledby="planos-ind-heading">
                        <h2 id="planos-ind-heading" className={styles.subsectionTitle}>
                            Planos mensais (individual)
                        </h2>
                        <p className={styles.prose}>
                            Desconto progressivo conforme a frequência semanal. Valores mensais com equivalência por
                            hora/aula indicada abaixo.
                        </p>

                        <div className={styles.pricingSection} aria-label="Tabela planos individuais">
                            <div className={styles.planCard}>
                                <p className={styles.planName}>5x na semana</p>
                                <p className={styles.planPeriod}>R$ 800,00 / mês</p>
                                <p className={styles.planMuted}>Equivale a R$ 40,00 por hora/aula</p>
                                <a
                                    href={wa(MSG_IND_5)}
                                    className={styles.planWhatsapp}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <WhatsappIcon height="18" color="#ffffff" />
                                    <span>Quero este plano (5x)</span>
                                </a>
                            </div>
                            <div className={styles.planCard}>
                                <p className={styles.planName}>4x na semana</p>
                                <p className={styles.planPeriod}>R$ 640,00 / mês</p>
                                <p className={styles.planMuted}>Equivale a R$ 40,00 por hora/aula</p>
                                <a
                                    href={wa(MSG_IND_4)}
                                    className={styles.planWhatsapp}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <WhatsappIcon height="18" color="#ffffff" />
                                    <span>Quero este plano (4x)</span>
                                </a>
                            </div>
                            <div className={styles.planCard}>
                                <p className={styles.planName}>3x na semana</p>
                                <p className={styles.planPeriod}>R$ 540,00 / mês</p>
                                <p className={styles.planMuted}>Equivale a R$ 45,00 por hora/aula</p>
                                <a
                                    href={wa(MSG_IND_3)}
                                    className={styles.planWhatsapp}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <WhatsappIcon height="18" color="#ffffff" />
                                    <span>Quero este plano (3x)</span>
                                </a>
                            </div>
                            <div className={styles.planCard}>
                                <p className={styles.planName}>2x na semana</p>
                                <p className={styles.planPeriod}>R$ 360,00 / mês</p>
                                <p className={styles.planMuted}>Equivale a R$ 45,00 por hora/aula</p>
                                <a
                                    href={wa(MSG_IND_2)}
                                    className={styles.planWhatsapp}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <WhatsappIcon height="18" color="#ffffff" />
                                    <span>Quero este plano (2x)</span>
                                </a>
                            </div>
                        </div>
                    </section>

                    <section className={styles.section} aria-labelledby="planos-dup-heading">
                        <h2 id="planos-dup-heading" className={styles.subsectionTitle}>
                            Planos mensais (dupla ou casal)
                        </h2>
                        <p className={styles.prose}>
                            Treinem juntos com economia por pessoa e a mesma exigência técnica do acompanhamento
                            individualizado.
                        </p>

                        <div className={styles.pricingSection} aria-label="Tabela planos dupla">
                            <div className={styles.planCard}>
                                <p className={styles.planName}>5x na semana</p>
                                <p className={styles.planPeriod}>R$ 1.200,00 / mês</p>
                                <p className={styles.planMuted}>Equivale a R$ 30,00 por hora/aula (por pessoa)</p>
                                <a
                                    href={wa(MSG_DUP_5)}
                                    className={styles.planWhatsapp}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <WhatsappIcon height="18" color="#ffffff" />
                                    <span>Quero dupla 5x na semana</span>
                                </a>
                            </div>
                            <div className={styles.planCard}>
                                <p className={styles.planName}>4x na semana</p>
                                <p className={styles.planPeriod}>R$ 1.120,00 / mês</p>
                                <p className={styles.planMuted}>Equivale a R$ 35,00 por hora/aula (por pessoa)</p>
                                <a
                                    href={wa(MSG_DUP_4)}
                                    className={styles.planWhatsapp}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <WhatsappIcon height="18" color="#ffffff" />
                                    <span>Quero dupla 4x na semana</span>
                                </a>
                            </div>
                            <div className={styles.planCard}>
                                <p className={styles.planName}>3x na semana</p>
                                <p className={styles.planPeriod}>R$ 900,00 / mês</p>
                                <p className={styles.planMuted}>Equivale a R$ 37,50 por hora/aula (por pessoa)</p>
                                <a
                                    href={wa(MSG_DUP_3)}
                                    className={styles.planWhatsapp}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <WhatsappIcon height="18" color="#ffffff" />
                                    <span>Quero dupla 3x na semana</span>
                                </a>
                            </div>
                            <div className={styles.planCard}>
                                <p className={styles.planName}>2x na semana</p>
                                <p className={styles.planPeriod}>R$ 600,00 / mês</p>
                                <p className={styles.planMuted}>Equivale a R$ 37,50 por hora/aula (por pessoa)</p>
                                <a
                                    href={wa(MSG_DUP_2)}
                                    className={styles.planWhatsapp}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <WhatsappIcon height="18" color="#ffffff" />
                                    <span>Quero dupla 2x na semana</span>
                                </a>
                            </div>
                        </div>
                    </section>
                </div>

                <p className={styles.footerNote}>
                    Valores e disponibilidade de horários são confirmados no atendimento. Resultados dependem de
                    frequência, esforço e orientações seguidas.
                </p>

                <div className={styles.ctaSection} aria-labelledby="cta-pres-heading">
                    <h2 id="cta-pres-heading" className={styles.ctaHeading}>
                        Prefere que eu te indique o melhor plano?
                    </h2>
                    <p className={styles.ctaText}>
                        Me conte seu objetivo, dias da semana que você consegue treinar e se é individual ou dupla.
                        Monto a sugestão mais inteligente para o seu bolso e para o seu resultado.
                    </p>
                    <a
                        href={wa(MSG_GERAL)}
                        className={styles.ctaWhatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <WhatsappIcon height="22" color="#ffffff" />
                        <span>Falar com o Anderson</span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Andersoncruz_personal_acompanhamentopresencial;
